export function createStorageKey(key: string) {
  return `flash:${key}`;
}
